// UCSF-3791: a notification's target is a relative GritxSite path stored by the server. Anything else (an absolute or
// protocol-relative URL, a backslash trick) is ignored, so a link can never take the patient off-site.
export const toInternalPath = (link?: string | null): string | null => {
  if (!link || !link.startsWith('/') || link.startsWith('//') || link.includes('\\')) {
    return null;
  }

  return link;
};
